<template>
  <div>
    <div class="row">
      <div class="col">
        <label for="first_name" class="control-label">{{ $t('first_name') }}</label>
        <fg-input
          type="text"
          id="first_name"
          :placeholder="$t('first_name')"
          v-model="first_name"
          addon-left-icon="ti ti-pencil"
          @input="$emit('update:first_name', first_name)"
        >
        </fg-input>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="first_name" class="control-label">{{ $t('last_name') }}</label>
        <fg-input
          type="text"
          id="last_name"
          :placeholder="$t('last_name')"
          v-model="last_name"
          addon-left-icon="ti ti-pencil"
          @input="$emit('update:last_name', last_name)"
        >
        </fg-input>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="first_name" class="control-label">{{ $t('email') }}</label>
        <fg-input
          type="email"
          id="email"
          required
          :placeholder="$t('email')"
          v-model="email"
          addon-left-icon="ti ti-email"
          @input="$emit('update:email', email)"
        >
        </fg-input>
      </div>
    </div>
  </div>
</template>

<script>
import SvgName from '../svg/SvgName';
export default {
  name: 'CreateUserContent',
  components: { SvgName },
  data: function () {
    return {
      first_name: null,
      last_name: null,
      email: null,
    };
  },
};
</script>

<style scoped></style>
